<h2 mat-dialog-title>{{ 'Popup.Profession.Title' | translate }}</h2>
<div mat-dialog-content>
  <p>
    {{ 'Popup.Profession.Content' | translate }}
    <br />
  </p>
  <app-popup-support></app-popup-support>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{ 'Global.Close' | translate }}
  </button>
</div>
